import {init as i18nInit} from '@modifi/plugin-i18n/register'
import '@modifi/plugin-google-tag-manager/register'
import '@modifi/website-client/register'

export const initPlugins = (options = {}) => Promise.all([i18nInit(options?.i18n)])
